// 设计构思
import React from 'react'
import Text from '../../components/Text'
import Title from '../../components/Title'

const DesignConcept = ({ text }) => {
  return (
    <>
      <Title title="设计构思" />
      <Text text={text} />
    </>
  )
}

export default DesignConcept
